import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getAACTData,
  getAACTStatuses,
} from "../../../../state/selectors/AACT.selectors";
import { AACTType } from "../../../componentTypes/AACType";

const GeneAACTCard = ({ card, aactData, statuses }) => {
  const isDisabled = !Object.keys(aactData || {}).length;

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      classCardItem="card-item card-item-larger"
    >
      <div className="tw-flex tw-flex-wrap">
        {statuses &&
          Object.entries(statuses).map((item) => {
            if (
              item[0].toLowerCase().includes("recruiting") ||
              item[0].toLowerCase().includes("active")
            ) {
              return (
                <div
                  className="tw-mr-1.5"
                  key={item[0]}
                  data-testid="aact-status"
                >
                  {`${item[0]}: `}
                  <b>{`${item[1]} `}</b>
                </div>
              );
            }
            return null;
          })}
      </div>
    </CardWrapper>
  );
};

GeneAACTCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  aactData: AACTType,
  statuses: PropTypes.shape({}),
};

GeneAACTCard.defaultProps = {
  aactData: {},
  statuses: null,
};

const mapStateToProps = (state) => ({
  aactData: getAACTData(state),
  statuses: getAACTStatuses(state),
});

export default connect(mapStateToProps)(GeneAACTCard);
